module.exports = __webpack_public_path__ + "img/mobileiot8.e3125e93.png";